import React, {useState, useEffect} from 'react';
import {Spinner} from 'react-bootstrap';
import OutlookTitle from './OutlookTitle';
import FileAttachments from '../../../../components/FileAttachments/FileAttachments';
import {Text, Box, PreviewContainer} from '../../../../styled';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';
import EntityIcon from '../../../../components/EntityIcon/EntityIcon';


const OutlookPreview = ({ item }:any) => {
  const [messagePreview, setMessagePreview] = useState(item.fullMessage);

  useEffect(() => {
    const timeout = setTimeout(() => {
      item.resultMessage();
      setMessagePreview(item.fullMessage);
      clearTimeout(timeout);
    }, 200);
  }, []);

  return (
    <Box display="flex" flexDirection="column" overflow="hidden" width="100%">
      <Box display="flex" alignItems="center">
        <Box mr={20}>
          <EntityIcon entityName={item.pl} />
        </Box>
        <OutlookTitle title={item.title} sender={item.sender} />
      </Box>
      <PreviewContainer
        display="flex" flexDirection="column"
        ml={[0, 60]} flex="1"
      >
        {messagePreview ? (
          <Box
            bg={'#fff'}
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            justifyItems={'center'}
            p={15}
            maxWidth={'100%'}
          >
            <HighlightMarker>
              {messagePreview}
            </HighlightMarker>
          </Box>
        ) : (
          <Box display="flex" justifyContent="center" paddingTop={40} paddingBottom={40}>
            <Spinner animation="border" style={{ color: '#1C62EF' }} />
          </Box>
        )}
        <FileAttachments files={item.att} />
        <Text variant="muted" size="small" >
          {item.email} | {item.date || 'Not available'}
        </Text>
      </PreviewContainer>
    </Box>
  )
}

export default OutlookPreview;